import { useEffect, useState } from "react";
import ConsentRefreshIcon from "../../assets/images/ConsentRefreshIcon";
import { consentConstant } from "../../constants/constants";
import ConsentAlreadyAcceptedRefreshIcon from "../../assets/images/ConsentAlreadyAcceptedRefreshIcon";

export const ConsentRefreshComponent = ({
  setRefreshScreen,
  consentDetailsErrorMessage,
}: any) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [showIconForTandCAlreadyAccepted, setShowIconForTandCAlreadyAccepted] =
    useState(false);
  useEffect(() => {
    if (consentDetailsErrorMessage === consentConstant.consentAlreadyCompleted) {
      setErrorMessage(consentDetailsErrorMessage);
      setErrorDescription(consentConstant.consentAlreadyCompletedDescription);
      setShowIconForTandCAlreadyAccepted(true);
    } else {
      setErrorMessage(consentConstant.consentRefreshHeader);
      setErrorDescription(consentConstant.consentRefreshDescription);
      setShowIconForTandCAlreadyAccepted(false);
    }
  }, [consentDetailsErrorMessage]);

  return (
    <div className="bg-whiteColor rounded-lg h-[75vh] flex flex-col justify-center">
      <div className="text-center StaffList pt-12">{errorMessage}</div>
      <div className="text-center consentRefreshDescription text-consentRefreshDescriptionColor pt-3">
        {errorDescription}
      </div>
      <div className="pt-12 flex justify-center">
        {showIconForTandCAlreadyAccepted ? (
          <ConsentAlreadyAcceptedRefreshIcon />
        ) : (
          <ConsentRefreshIcon />
        )}
      </div>
      <div
        className="bg-primary text-whiteColor py-3 mx-4 my-16 text-center"
        onClick={() => {
          setRefreshScreen(true);
        }}
      >
        {consentConstant.refresh}
      </div>
    </div>
  );
};
